import { SyntheticEvent, useState } from "react";
import { Card, Tab, Tabs } from "@mui/material";

import ModelosCertificados from "./ModelosCertificados";
import RelatorioCertificadosEmitidos from "./RelatorioCertificadosEmitidos";
import ValidarCertificado from "../Certificados/ValidarCertificado";
import styles from "../Shared/AdminWorkspace.module.css";

type CertificadoTab = "modelos" | "emitidos" | "validar";

const CertificadosDeclaracoesAdmin = () => {
  const [activeTab, setActiveTab] = useState<CertificadoTab>("modelos");

  return (
    <div className={styles.container}>
      <Card className={styles.tabsCard}>
        <div className={styles.tabsWrap}>
          <Tabs
            value={activeTab}
            onChange={(_: SyntheticEvent, value: CertificadoTab) => setActiveTab(value)}
          >
            <Tab value="modelos" label="Modelos" />
            <Tab value="emitidos" label="Certificados Emitidos" />
            <Tab value="validar" label="Validar Certificado" />
          </Tabs>
        </div>

        <div className={styles.content}>
          {activeTab === "modelos" && <ModelosCertificados />}
          {activeTab === "emitidos" && <RelatorioCertificadosEmitidos />}
          {activeTab === "validar" && <ValidarCertificado embedded />}
        </div>
      </Card>
    </div>
  );
};

export default CertificadosDeclaracoesAdmin;
